/**
 * Client-side JWT payload read (no signature verification — backend is source of truth).
 * Used only to schedule proactive access-token refresh before expiry.
 */

export function readJwtExpiryMs(accessToken: string): number | null {
  try {
    const parts = accessToken.split('.');
    if (parts.length < 2) return null;
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = b64.length % 4;
    if (pad) b64 += '='.repeat(4 - pad);
    const payload = JSON.parse(atob(b64));
    const expSec = typeof payload.exp === 'number' ? payload.exp : null;
    if (expSec == null) return null;
    return expSec * 1000;
  } catch {
    return null;
  }
}
